module.exports = __webpack_public_path__ + "img/bu-head-duration.94663e8a.svg";